import { useState } from "react";
import { Reveal } from "@/components/motion/Reveal";

const FORMSUBMIT_ENDPOINT = "https://formsubmit.co/hello@shopveylle.com";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const redirect =
    typeof window !== "undefined"
      ? `${window.location.origin}/`
      : "/";

  return (
    <div data-testid="contact-page">
      <section data-testid="contact-hero" className="bg-ivory">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 pt-32 md:pt-48 pb-16">
          <p className="eyebrow eyebrow-brass mb-6">Contact</p>
          <h1 className="font-display leading-[1.02]" style={{ fontSize: "clamp(60px, 10vw, 160px)", fontWeight: 300 }}>
            Say hello to the <em className="italic">house.</em>
          </h1>
          <p className="mt-10 max-w-2xl text-[16px] leading-[1.8] text-pencil">
            For press, partnerships, stockists, or anything at all — write to us. We read every note.
          </p>
        </div>
      </section>

      <section data-testid="contact-form" className="bg-cream">
        <div className="max-w-[1600px] mx-auto px-6 md:px-10 py-24 md:py-32 grid md:grid-cols-12 gap-14">
          <div className="md:col-span-4 space-y-8">
            <div>
              <p className="font-mono-stamp text-pencil">General</p>
              <a href="mailto:hello@shopveylle.com" data-testid="contact-email-link" className="mt-2 block font-display text-3xl link-underline">
                hello@shopveylle.com
              </a>
            </div>
            <div>
              <p className="font-mono-stamp text-pencil">Press</p>
              <a href="mailto:press@shopveylle.com" data-testid="contact-press-link" className="mt-2 block font-display text-3xl link-underline">
                press@shopveylle.com
              </a>
            </div>
            <div>
              <p className="font-mono-stamp text-pencil">Instagram</p>
              <a href="https://instagram.com/byveylle" target="_blank" rel="noreferrer noopener" data-testid="contact-instagram-link" className="mt-2 block font-display text-3xl link-underline">
                @byveylle
              </a>
            </div>
            <div className="pt-6 border-t border-ink/10">
              <p className="font-display italic text-2xl text-pencil">
                Considered in small batches. Made to be refilled.
              </p>
            </div>
          </div>

          <div className="md:col-span-8">
            <Reveal>
              <form
                action={FORMSUBMIT_ENDPOINT}
                method="POST"
                acceptCharset="UTF-8"
                className="space-y-8"
                data-testid="contact-form-el"
              >
                {/* formsubmit.co config */}
                <input type="hidden" name="_subject" value="New note via shopveylle.com" />
                <input type="hidden" name="_template" value="table" />
                <input type="hidden" name="_captcha" value="false" />
                <input type="hidden" name="_next" value={redirect} />
                {/* Honeypot */}
                <input type="text" name="_honey" style={{ display: "none" }} tabIndex={-1} autoComplete="off" />

                <div>
                  <label className="font-mono-stamp text-pencil block mb-3" htmlFor="c-name">Name</label>
                  <input
                    id="c-name"
                    name="name"
                    data-testid="contact-name"
                    value={form.name}
                    onChange={update("name")}
                    className="input-box"
                    required
                  />
                </div>
                <div>
                  <label className="font-mono-stamp text-pencil block mb-3" htmlFor="c-email">Email</label>
                  <input
                    id="c-email"
                    name="email"
                    type="email"
                    data-testid="contact-email"
                    value={form.email}
                    onChange={update("email")}
                    className="input-box"
                    required
                  />
                </div>
                <div>
                  <label className="font-mono-stamp text-pencil block mb-3" htmlFor="c-msg">Message</label>
                  <textarea
                    id="c-msg"
                    name="message"
                    rows={7}
                    data-testid="contact-message"
                    value={form.message}
                    onChange={update("message")}
                    className="input-box resize-none"
                    required
                  />
                </div>
                <button
                  type="submit"
                  data-testid="contact-submit"
                  className="btn-ink"
                >
                  Send
                </button>
              </form>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
